import { CapoPlugin } from "/vercel/path0/node_modules/.pnpm/@unhead+vue@1.11.20_vue@3.5.42_typescript@5.9.3_/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];